import {TransactionHistoryState} from './interfaces'

export const getInitialState = (): TransactionHistoryState => ({
    items: [],
})
